<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>
<div class="card-layout card">
    <div class="row">
        <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
            <div *ngIf="fromPage != 'ServiceRequestInvoice'" class="largeScreen">
                <ul class="nav nav-tabs mb-3">
                    <li class="active" (click)="showButton = 'Note'">
                        <a class="tab_color pl-0 pr-1 item" data-toggle="tab" href="#notes"
                            ><b>Notes ({{ notes.length }})</b></a
                        >
                    </li>
                    <li *ngIf="fromPage != 'ServiceRequestInvoice' && fromPage != 'common-itinerary'" (click)="showButton = 'File'">
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#file"
                            ><b>File ({{ totalCountFiles }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="
                            fromPage != 'vendor' &&
                            fromPage != 'customer' &&
                            fromPage != 'ServiceRequestInvoice' &&
                            fromPage == 'Preview' &&
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR &&
                            fromPage != 'common-itinerary'
                        "
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#srlogs"
                            ><b>Service Request Logs ({{ SRLogs.length }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="
                            fromPage != 'vendor' &&
                            fromPage != 'customer' &&
                            fromPage != 'ServiceRequestInvoice' &&
                            fromPage != 'common-itinerary' &&
                            fromPage == 'Preview' &&
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR
                        "
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#srslogs"
                            ><b>Leg Logs ({{ SRSLogs.length }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="
                            fromPage != 'vendor' &&
                            fromPage != 'customer' &&
                            fromPage != 'ServiceRequestInvoice' &&
                            fromPage == 'Preview' &&
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR &&
                            fromPage != 'common-itinerary'
                        "
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#assignmnetlogs"
                            ><b> Assignment Logs ({{ assignmnetLog.length }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="
                            fromPage == 'Preview' &&
                            fromPage != 'common-itinerary' &&
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR
                        "
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#checklistLogs"
                            ><b>Checklist Log ({{ checkListLogs.length }})</b></a
                        >
                    </li>
                    <li *ngIf="fromPage == 'Preview' && isCatering && isAdmin" (click)="showButton = ''">
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#cateringLogs">
                            <b> Catering Logs ({{ cateringLogLength }}) </b>
                        </a>
                    </li>
                    <li
                        *ngIf="
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR &&
                            user.role != roleName.DRIVER &&
                            !isInternalReadOnly
                        "
                        class="mt-3 float-right"
                        [ngClass]="showButton == 'File' ? 'd-none' : 'd-block'"
                    >
                        <span
                            *ngIf="showButton != ''"
                            class="mr-2 cursorPointer text-color"
                            data-target="#addNoteFeedback"
                            data-toggle="modal"
                            (click)="openAddNoteFeedbackModel(showButton)"
                        >
                            <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                            <b>{{ showButton }}</b>
                        </span>
                    </li>
                    <li
                        *ngIf="
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR &&
                            user.role != roleName.DRIVER &&
                            !isInternalReadOnly &&
                            fromPage != 'common-itinerary'
                        "
                        class="mt-3 float-right"
                        [ngClass]="showButton == 'File' ? 'd-block' : 'd-none'"
                    >
                        <span *ngIf="showButton != ''" class="mr-2 cursorPointer text-color" (click)="openCreateFileModal()">
                            <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                            <b>{{ showButton }}</b>
                        </span>
                    </li>
                </ul>
            </div>
            <div *ngIf="fromPage != 'ServiceRequestInvoice'" class="smallScreen">
                <ul class="nav nav-tabs mb-3 navigation">
                    <li class="active" (click)="showButton = 'Note'">
                        <a class="tab_color pl-0 pr-1 item" data-toggle="tab" href="#notes"
                            ><b>Notes ({{ notes.length }})</b></a
                        >
                    </li>
                    <li *ngIf="fromPage != 'ServiceRequestInvoice' && fromPage != 'common-itinerary'" (click)="showButton = 'File'">
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#file"
                            ><b>File ({{ totalCountFiles }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="
                            fromPage != 'vendor' &&
                            fromPage != 'customer' &&
                            fromPage != 'ServiceRequestInvoice' &&
                            fromPage != 'common-itinerary'
                        "
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#srlogs"
                            ><b>Service Request Logs ({{ SRLogs.length }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="
                            fromPage != 'vendor' &&
                            fromPage != 'customer' &&
                            fromPage != 'ServiceRequestInvoice' &&
                            fromPage != 'common-itinerary'
                        "
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#srslogs"
                            ><b>Leg Logs ({{ SRSLogs.length }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="
                            fromPage != 'vendor' &&
                            fromPage != 'customer' &&
                            fromPage != 'ServiceRequestInvoice' &&
                            fromPage == 'Preview' &&
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR &&
                            fromPage != 'common-itinerary'
                        "
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#assignmnetlogs"
                            ><b>Assignmnet logs Log ({{ assignmnetLog.length }})</b>
                        </a>
                    </li>
                    <li
                        *ngIf="
                            fromPage == 'Preview' &&
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR &&
                            fromPage != 'common-itinerary'
                        "
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#checklistLogs"
                            ><b>Checklist Log ({{ checkListLogs.length }})</b></a
                        >
                    </li>
                    <li *ngIf="fromPage == 'Preview' && isCatering && isAdmin" (click)="showButton = ''">
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#cateringLogs">
                            <b> Catering Logs ({{ cateringLogLength }}) </b>
                        </a>
                    </li>
                    <li
                        *ngIf="
                            user.role != roleName.CUSTOMER_ADMIN &&
                            user.role != roleName.CUSTOMER_COORDINATOR &&
                            user.role != roleName.DRIVER &&
                            user.role != roleName.MANAGEMENT &&
                            !isInternalReadOnly
                        "
                        class="mt-3 float-right"
                        [ngClass]="showButton == 'File' ? 'd-none' : 'd-block'"
                    >
                        <span
                            class="mr-2 cursorPointer text-color"
                            data-target="#addNoteFeedback"
                            data-toggle="modal"
                            (click)="openAddNoteFeedbackModel(showButton)"
                        >
                            <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                            <b>{{ showButton }}</b>
                        </span>
                    </li>
                </ul>
            </div>
            <div *ngIf="fromPage == 'ServiceRequestInvoice'">
                <ul class="nav nav-tabs mb-3">
                    <li class="active" (click)="showButton = 'Note'">
                        <a class="tab_color pl-0 pr-1 item" data-toggle="tab" href="#notes"
                            ><b>Notes ({{ notes.length }})</b></a
                        >
                    </li>
                    <li *ngIf="fromPage != 'ServiceRequestInvoice'" (click)="showButton = 'File'">
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#file"
                            ><b>File ({{ totalCountFiles }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="fromPage != 'vendor' && fromPage != 'customer' && fromPage != 'ServiceRequestInvoice'"
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#srlogs"
                            ><b>Service Request Logs ({{ SRLogs.length }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="fromPage != 'vendor' && fromPage != 'customer' && fromPage != 'ServiceRequestInvoice'"
                        (click)="showButton = ''"
                    >
                        <a class="tab_color pl-1 pr-1 item" data-toggle="tab" href="#srslogs"
                            ><b>Leg Logs ({{ SRSLogs.length }})</b></a
                        >
                    </li>
                    <li
                        *ngIf="user.role != roleName.DRIVER && user.role != roleName.MANAGEMENT && !isInternalReadOnly"
                        class="mt-3 float-right"
                        [ngClass]="showButton == 'File' ? 'd-none' : 'd-block'"
                    >
                        <span
                            *ngIf="showButton != ''"
                            class="mr-2 cursorPointer text-color"
                            data-target="#addNoteFeedback"
                            data-toggle="modal"
                            (click)="openAddNoteFeedbackModel(showButton)"
                        >
                            <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                            <b>{{ showButton }}</b>
                        </span>
                    </li>
                </ul>
            </div>
            <div class="tab-content">
                <div id="notes" class="tab-pane active">
                    <div class="col-md-12 col-sm-12 col-xs-12 px-0 mb-2">
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 px-0">
                            <div class="filter-options">
                                <span>Show</span>
                                <select
                                    class="ml-2 grid-header-element number-sort-filter"
                                    aria-controls="example1"
                                    name="example1_length"
                                    [(ngModel)]="selectedPageForNotes"
                                    (change)="selectMemberPage('Notes')"
                                >
                                    <option *ngFor="let number of numberOfEntries" [value]="number.numberOfEntries">
                                        {{ number.numberOfEntries }}
                                    </option>
                                </select>
                                <span class="ml-2">entries</span>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 text-lg-right px-0">
                            <div class="row">
                                <div class="col-lg-7 offset-lg-7"></div>
                                <!-- ABOVE LINE OF CODE IS NEEDED FOR UI STABILIZATION -->
                                <div class="col-lg-5">
                                    <div id="example1_filter" class="d-flex float-right align-items-center">
                                        <span>Search</span>
                                        <input
                                            class="ml-2 form-control form-control-sm grid-header-element searchbar-element"
                                            aria-controls="example1"
                                            type="search"
                                            [(ngModel)]="searchNotes"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table id="jobid" class="table card-layout table-striped table mt-0">
                        <thead>
                            <tr>
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <!--<div class="header_title s_no">#</div>-->
                                        <div
                                            class="header_title width_10 cursorPointer"
                                            (click)="notesSortBy = 'createdOn'; sortOrder = !sortOrder; date = !date"
                                        >
                                            Date
                                            <i *ngIf="date == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="date == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_10 cursorPointer"
                                            (click)="notesSortBy = 'createdBy'; sortOrder = !sortOrder; by = !by"
                                        >
                                            By
                                            <i *ngIf="by == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="by == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_10 cursorPointer"
                                            (click)="notesSortBy = 'noteCategory'; sortOrder = !sortOrder; category = !category"
                                        >
                                            Category
                                            <i *ngIf="category == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="category == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="notesSortBy = 'noteDescription'; sortOrder = !sortOrder; note = !note"
                                        >
                                            Note
                                            <i *ngIf="note == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="note == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div *ngIf="user.role != roleName.VENDOR_COORDINATOR" class="header_title width_10">Action</div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let note of notes
                                        | orderBy: notesSortBy : sortOrder : prioritySorting
                                        | filter: searchNotes
                                        | paginate
                                            : {
                                                  id: 'notePageination',
                                                  itemsPerPage: selectedPageForNotes,
                                                  currentPage: currentPageForNotes,
                                              };
                                    let i = index
                                "
                            >
                                <td>
                                    <div class="row_container" [class.note-deleted]="note.isActive != true">
                                        <div class="title_container width_10">
                                            <div class="row_title">Date</div>
                                            <div class="row_detail">
                                                {{ note.createdOn | localDate: timeZone }}
                                            </div>
                                        </div>
                                        <div class="title_container width_10">
                                            <div class="row_title">By</div>
                                            <div class="row_detail">
                                                <span>{{ note?.createdBy }}</span>
                                                <!-- <span *ngIf="createdBy==null">Sam Billing</span> -->
                                            </div>
                                        </div>
                                        <div class="title_container width_10">
                                            <div class="row_title">Category</div>
                                            <div class="row_detail">
                                                {{ note.noteCategory }}
                                                <span
                                                    *ngIf="
                                                        note.level == 'Service Request Step' &&
                                                        fromPage != 'customer' &&
                                                        fromPage != 'vendor'
                                                    "
                                                >
                                                    <span class="badge heading-font-size picked-Up-class"> Leg Note </span>
                                                    <span *ngIf="note.isDeleted == true" class="badge heading-font-size"> Deleted </span>
                                                </span>
                                                <span
                                                    *ngIf="
                                                        (note.level == 'Service Request' || note.level == 'Vendor') &&
                                                        fromPage != 'customer' &&
                                                        fromPage != 'vendor'
                                                    "
                                                >
                                                    <span class="badge heading-font-size enroute-class"> SR Note </span>
                                                </span>
                                                <span *ngIf="note.level == 'VendorNote'">
                                                    <span class="badge heading-font-size region-central"> Vendor Note </span>
                                                </span>
                                                <span *ngIf="note.level == 'CustomerNote'">
                                                    <span class="badge heading-font-size not_started-class"> Customer Note </span>
                                                </span>
                                                <span *ngIf="note.level == 'Catering'">
                                                    <span class="badge heading-font-size on-scene-status-class"> Catering Note </span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="title_container width_70" style="word-break: break-all">
                                            <div class="row_title">Note</div>
                                            <div class="row_detail">
                                                {{ note.noteDescription }}
                                            </div>
                                        </div>
                                        <div *ngIf="user.role != roleName.VENDOR_COORDINATOR" class="title_container width_10">
                                            <div class="row_title">Action</div>
                                            <div class="row_detail">
                                                <button
                                                    *ngIf="fromPage != 'Preview'"
                                                    class="flat-butt flat-danger-butt flat-danger-grad-butt delete-icon"
                                                    title="Delete Note"
                                                    type="button"
                                                    [disabled]="note.isActive != true || isInternalReadOnly"
                                                    [ngClass]="note.isActive != true || isInternalReadOnly ? 'cursorDisabled' : ''"
                                                    (click)="deleteNote(note.noteID)"
                                                >
                                                    <i class="fa fa-minus-circle"></i>
                                                </button>
                                                <button
                                                    *ngIf="note.isActive == true"
                                                    class="flat-butt save-btn delete-icon"
                                                    title="Add Priority"
                                                    type="button"
                                                    [disabled]="isInternalReadOnly"
                                                    [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''"
                                                    (click)="notePriority(note)"
                                                >
                                                    <i
                                                        class="fa fa-star"
                                                        [ngClass]="{ notePriority: note.priority == null ? false : note.priority }"
                                                    ></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="notes.length == 0" class="text-color"><b>No Record Available</b></div>
                    <div *ngIf="notes.length != 0" class="col-md-12 p-0">
                        <div id="left" class="col-md-6 p-0">
                            {{ notesPagination }}
                        </div>

                        <div id="right" class="col-md-6 pagination text-end">
                            <pagination-controls
                                id="notePageination"
                                [nextLabel]="R"
                                [previousLabel]="N"
                                [responsive]="responsive"
                                (pageChange)="currentPageForNotes = $event; currentPageChange('Notes')"
                            >
                            </pagination-controls>
                        </div>
                    </div>
                </div>
                <div *ngIf="fromPage != 'common-itinerary'" id="file" class="tab-pane">
                    <div class="col-md-12 col-sm-12 col-xs-12 px-0 mb-2">
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 px-0">
                            <div class="filter-options">
                                <span>Show</span>
                                <select
                                    class="ml-2 grid-header-element number-sort-filter"
                                    aria-controls="example1"
                                    name="example1_length"
                                    [(ngModel)]="selectedPageForFiles"
                                    (change)="selectMemberPage('Files')"
                                >
                                    <option *ngFor="let number of numberOfEntries" [value]="number.numberOfEntries">
                                        {{ number.numberOfEntries }}
                                    </option>
                                </select>
                                <span class="ml-2">entries</span>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 text-lg-right px-0">
                            <div class="row">
                                <div class="col-lg-7 offset-lg-7"></div>
                                <!-- ABOVE LINE OF CODE IS NEEDED FOR UI STABILIZATION -->
                                <div class="col-lg-5">
                                    <div id="example1_filter" class="d-flex float-right align-items-center">
                                        <span>Search</span>
                                        <input
                                            class="ml-2 form-control form-control-sm grid-header-element searchbar-element"
                                            aria-controls="example1"
                                            type="search"
                                            [(ngModel)]="searchFiles"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table id="jobid" class="table card-layout table-striped table mt-0">
                        <thead>
                            <tr>
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <div
                                            class="header_title cursorPointer"
                                            [style.width]="isMobileDevice === true ? '30%' : '100%'"
                                            (click)="sortColumn('fileName', 'fileName')"
                                        >
                                            File Name
                                            <i *ngIf="fileName" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!fileName" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title cursorPointer"
                                            [style.width]="isMobileDevice === true ? '17.5%' : '100%'"
                                            (click)="sortColumn('uploadedOnColumn', 'createdOn')"
                                        >
                                            Uploaded On
                                            <i *ngIf="uploadedOnColumn" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!uploadedOnColumn" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            *ngIf="isCustomerOrVendorPage()"
                                            class="header_title cursorPointer"
                                            [style.width]="isMobileDevice === true ? '17.5%' : '100%'"
                                            (click)="sortColumn('fileTag', 'fileAttachmentTagName')"
                                        >
                                            File Tag
                                            <i *ngIf="fileTag" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!fileTag" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title cursorPointer"
                                            [style.width]="isMobileDevice === true ? '17.5%' : '100%'"
                                            (click)="sortColumn('fileCreatedBy', 'fileCreatedBy')"
                                        >
                                            Created By
                                            <i *ngIf="fileCreatedBy" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!fileCreatedBy" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header_title cursorPointer" [style.width]="isMobileDevice === true ? '17.5%' : '100%'">
                                            Action
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let file of files
                                        | orderBy: sortFileType : sortOrder : prioritySortingFiles
                                        | filter: searchFiles
                                        | paginate
                                            : {
                                                  id: 'filePagination',
                                                  itemsPerPage: selectedPageForFiles,
                                                  currentPage: currentPageForFiles,
                                                  totalItems: totalCountFiles,
                                              };
                                    trackBy: trackByFn
                                "
                            >
                                <td>
                                    <div class="row_container">
                                        <div class="title_container" [style.width]="isMobileDevice === true ? '30%' : '100%'">
                                            <div class="row_title">File Name</div>
                                            <div class="row_detail">
                                                <a class="cursorPointer" style="color: #a82b41" (click)="downloadFile(file)"
                                                    >{{ file?.displayName || file?.fileName }}
                                                </a>
                                                <sup *ngIf="file.uploadedFrom == 'Itinary' || file.uploadedFrom == 'ServiceRequestStep'">
                                                    <span
                                                        class="badge"
                                                        [ngClass]="{
                                                            'bg-red': file.uploadedFrom == 'Itinary',
                                                            'bg-green': file.uploadedFrom == 'ServiceRequestStep',
                                                        }"
                                                    >
                                                        {{
                                                            file.uploadedFrom == 'Itinary'
                                                                ? 'SR File'
                                                                : file.uploadedFrom == 'ServiceRequestStep'
                                                                  ? 'Leg File'
                                                                  : ''
                                                        }}
                                                    </span>
                                                </sup>
                                            </div>
                                        </div>
                                        <div class="title_container" [style.width]="isMobileDevice === true ? '17.5%' : '100%'">
                                            <div class="row_title">Uploaded On</div>
                                            <div class="row_detail">
                                                <b>{{ file?.createdOn | localDate: timeZone }}</b>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="isCustomerOrVendorPage()"
                                            class="title_container"
                                            [style.width]="isMobileDevice === true ? '17.5%' : '100%'"
                                        >
                                            <div class="row_title">File Tag</div>
                                            <div class="row_detail">
                                                <span
                                                    *ngIf="file?.fileAttachmentTagName"
                                                    class="badge"
                                                    [ngClass]="fileAttachmentTagStatusClass[file?.fileAttachmentTagName]"
                                                >
                                                    {{ file?.fileAttachmentTagName }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="title_container" [style.width]="isMobileDevice === true ? '17.5%' : '100%'">
                                            <div class="row_title">Created By</div>
                                            <div class="row_detail">
                                                <b>{{ file?.creatorName }}</b>
                                            </div>
                                        </div>
                                        <div class="title_container" [style.width]="isMobileDevice === true ? '17.5%' : '100%'">
                                            <div class="row_title">Action</div>
                                            <div class="row_detail">
                                                <button
                                                    class="flat-butt save-btn delete-icon"
                                                    [class.cursorDisabled]="isInternalReadOnly"
                                                    title="Add Priority"
                                                    type="button"
                                                    [disabled]="isInternalReadOnly"
                                                    (click)="pinItem(file)"
                                                >
                                                    <i class="fa fa-star" [class.notePriority]="file?.isPinned"></i>
                                                </button>
                                                <ng-container *ngIf="fromPage !== 'Preview'">
                                                    <button
                                                        class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                        title="Edit File"
                                                        [disabled]="isInternalReadOnly"
                                                        [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''"
                                                        (click)="openEditFileModal(file)"
                                                    >
                                                        <i class="fa fa-pencil-square"></i>
                                                    </button>
                                                    <button
                                                        *ngIf="
                                                            user.role !== roleName.VENDOR_COORDINATOR &&
                                                            user.role !== roleName.CUSTOMER_COORDINATOR &&
                                                            user.role !== roleName.COORDINATOR &&
                                                            user.role !== roleName.MANAGEMENT
                                                        "
                                                        class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                        title="Remove {{ file?.fileName }}.{{ file?.extension }} file"
                                                        type="button"
                                                        [disabled]="isInternalReadOnly"
                                                        [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''"
                                                        (click)="removeFile(file.fileId)"
                                                    >
                                                        <i class="fa fa-minus-circle"></i></button
                                                    ><br />
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="files.length === 0" class="text-color"><b>No Record Available</b></div>
                    <div *ngIf="files.length != 0" class="col-md-12 p-0">
                        <div id="left" class="col-md-6 p-0">
                            {{ filePagination }}
                        </div>
                        <div id="right" class="col-md-6 pagination text-end">
                            <pagination-controls
                                id="filePagination"
                                nextLabel=""
                                previousLabel=""
                                (pageChange)="onPageChangeFiles($event)"
                            ></pagination-controls>
                        </div>
                    </div>
                </div>

                <!-- for Service Request logs-->

                <div *ngIf="fromPage != 'common-itinerary'" id="srlogs" class="tab-pane">
                    <div class="col-md-12 col-sm-12 col-xs-12 px-0 mb-2">
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 px-0">
                            <div class="filter-options">
                                <span>Show</span>
                                <select
                                    class="ml-2 grid-header-element number-sort-filter"
                                    aria-controls="example1"
                                    name="example1_length"
                                    [(ngModel)]="selectedPageForSRLogs"
                                    (change)="selectMemberPage('SRLogs')"
                                >
                                    <option *ngFor="let number of numberOfEntries" [value]="number.numberOfEntries">
                                        {{ number.numberOfEntries }}
                                    </option>
                                </select>
                                <span class="ml-2">entries</span>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 text-lg-right px-0">
                            <div class="row">
                                <div class="col-lg-7 offset-lg-7"></div>
                                <!-- ABOVE LINE OF CODE IS NEEDED FOR UI STABILIZATION -->
                                <div class="col-lg-5">
                                    <div id="example1_filter" class="d-flex float-right align-items-center">
                                        <span>Search</span>
                                        <input
                                            class="ml-2 form-control form-control-sm grid-header-element searchbar-element"
                                            aria-controls="example1"
                                            type="search"
                                            [(ngModel)]="searchSRLogs"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table id="jobid" class="table card-layout table-striped table mt-0">
                        <thead>
                            <tr>
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <!--<div class="header_title s_no">#</div>-->
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="SRLogsSortBy = 'source'; sortOrder = !sortOrder; SRLogsOrigin = !SRLogsOrigin"
                                        >
                                            Origin
                                            <i *ngIf="SRLogsOrigin" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsOrigin" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                SRLogsSortBy = 'destination'; sortOrder = !sortOrder; SRLogsDestination = !SRLogsDestination
                                            "
                                        >
                                            Destination
                                            <i *ngIf="SRLogsDestination" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsDestination" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                SRLogsSortBy = 'previousStatus';
                                                sortOrder = !sortOrder;
                                                SRLogsPreviousStatus = !SRLogsPreviousStatus
                                            "
                                        >
                                            Previous status
                                            <i *ngIf="SRLogsPreviousStatus" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsPreviousStatus" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                SRLogsSortBy = 'updatedStatus';
                                                sortOrder = !sortOrder;
                                                SRLogsUpdatedStatus = !SRLogsUpdatedStatus
                                            "
                                        >
                                            Updated status
                                            <i *ngIf="SRLogsUpdatedStatus" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsUpdatedStatus" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                SRLogsSortBy = 'updatedTime'; sortOrder = !sortOrder; SRLogsUpdatedTime = !SRLogsUpdatedTime
                                            "
                                        >
                                            Updated Time
                                            <i *ngIf="SRLogsUpdatedTime" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsUpdatedTime" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="SRLogsSortBy = 'updatedOn'; sortOrder = !sortOrder; SRLogsUpdatedBy = !SRLogsUpdatedBy"
                                        >
                                            Updated By
                                            <i *ngIf="SRLogsUpdatedBy" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsUpdatedBy" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                SRLogsSortBy = 'operationType';
                                                sortOrder = !sortOrder;
                                                SRLogsOperationType = !SRLogsOperationType
                                            "
                                        >
                                            Operation Type
                                            <i *ngIf="SRLogsOperationType" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsOperationType" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                SRLogsSortBy = 'previousValues';
                                                sortOrder = !sortOrder;
                                                SRLogsPreviousValues = !SRLogsPreviousValues
                                            "
                                        >
                                            Previous Values
                                            <i *ngIf="SRLogsPreviousValues" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsPreviousValues" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                SRLogsSortBy = 'updatedValues';
                                                sortOrder = !sortOrder;
                                                SRLogsUpdatedValues = !SRLogsUpdatedValues
                                            "
                                        >
                                            Updated Values
                                            <i *ngIf="SRLogsUpdatedValues" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!SRLogsUpdatedValues" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let sr of SRLogs
                                        | orderBy: SRLogsSortBy : sortOrder
                                        | filter: searchSRLogs
                                        | paginate
                                            : {
                                                  id: 'srLogsPagination',
                                                  itemsPerPage: selectedPageForSRLogs,
                                                  currentPage: SRLogsPagination,
                                              };
                                    let i = index
                                "
                            >
                                <td>
                                    <div class="row_container">
                                        <div class="title_container width_70">
                                            <div class="row_title">Origin</div>
                                            <div class="row_detail">
                                                {{ sr.source }}
                                                <br />
                                                {{ sr.sourceAddress }}<br />
                                                {{ sr?.sourceAddressLocation }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Destination</div>
                                            <div *ngFor="let destination of sr.destination" class="row_detail">
                                                {{ destination.destination }}

                                                <br />
                                                {{ destination.destinationAddress }}<br />
                                                {{ destination?.destinationAddressLocation }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Previous Status</div>
                                            <div class="row_detail">
                                                {{ sr.previousStatus }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated Status</div>
                                            <div class="row_detail">
                                                {{ sr.updatedStatus }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated Time</div>
                                            <div class="row_detail">
                                                {{ sr.updatedOn | localDate: timeZone }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated By</div>
                                            <div class="row_detail">
                                                {{ sr.updatedBy }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Operation Mode</div>
                                            <div class="row_detail">
                                                {{ sr.operationType }}
                                                <mat-icon
                                                    *ngIf="sr.templateId"
                                                    class="mat-icon text-danger cursorPointer ml-2"
                                                    aria-hidden="true"
                                                    data-mat-icon-type="font"
                                                    role="img"
                                                    title="Show template text"
                                                    (click)="showTemplateTextDialog(sr.templateId)"
                                                >
                                                    announcement
                                                </mat-icon>
                                                <mat-icon
                                                    *ngIf="sr.serviceRequestCancellationReasonId"
                                                    class="mat-icon text-danger cursorPointer ml-2"
                                                    aria-hidden="true"
                                                    data-mat-icon-type="font"
                                                    role="img"
                                                    title="cancellation reason"
                                                    (click)="cancellationReasonPopUp(sr.serviceRequestCancellationReasonId)"
                                                    >announcement</mat-icon
                                                >
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Previous Values</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="sr.previousValues">
                                                    <div *ngFor="let value of sr.previousValues.split('|')" class="mb-1">
                                                        <div>
                                                            <span class="text-bold"
                                                                >{{ value.substring(0, value.indexOf(':')).trim() }}:
                                                            </span>
                                                            <ng-container *ngIf="(value | dateChecker).isDate; else elseBlock">
                                                                <div>{{ (value | dateChecker)?.value | localDate: timeZone }}</div>
                                                            </ng-container>
                                                            <ng-template #elseBlock>
                                                                <span>{{ (value | dateChecker).value }}</span>
                                                            </ng-template>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="sr.previousValues == null || sr.previousValues === ''"
                                                    >NA</ng-container
                                                >
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated Values</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="sr.updatedValues">
                                                    <div *ngFor="let value of sr.updatedValues.split('|')" class="mb-1">
                                                        <div>
                                                            <span class="text-bold"
                                                                >{{ value.substring(0, value.indexOf(':')).trim() }}:
                                                            </span>
                                                            <ng-container *ngIf="(value | dateChecker).isDate; else elseBlock">
                                                                <div>{{ (value | dateChecker)?.value | localDate: timeZone }}</div>
                                                            </ng-container>
                                                            <ng-template #elseBlock>
                                                                <span>{{ (value | dateChecker).value }}</span>
                                                            </ng-template>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="sr.previousValues == null || sr.previousValues === ''"
                                                    >NA</ng-container
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="SRLogs.length == 0" class="text-color"><b>No Record Available</b></div>
                    <div *ngIf="SRLogs.length != 0" class="col-md-12 p-0">
                        <div id="left" class="col-md-6 p-0">
                            {{ SRLogsPaginationDes }}
                        </div>

                        <div id="right" class="col-md-6 pagination text-end">
                            <pagination-controls
                                id="srLogsPagination"
                                [nextLabel]="R"
                                [previousLabel]="N"
                                [responsive]="responsive"
                                (pageChange)="SRLogsPagination = $event; currentPageChange('SRLogs')"
                            >
                                {{ SRLogsPaginationDes }}
                            </pagination-controls>
                        </div>
                    </div>
                </div>

                <!-- for Service Request Steps logs-->

                <div *ngIf="fromPage != 'common-itinerary'" id="srslogs" class="tab-pane">
                    <div class="col-md-12 col-sm-12 col-xs-12 px-0 mb-2">
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 px-0">
                            <div class="filter-options">
                                <span>Show</span>
                                <select
                                    class="ml-2 grid-header-element number-sort-filter"
                                    aria-controls="example1"
                                    name="example1_length"
                                    [(ngModel)]="selectedPageForSRSLogs"
                                    (change)="selectMemberPage('SRSLogs')"
                                >
                                    <option *ngFor="let number of numberOfEntriesForLegLogs" [value]="number">
                                        {{ number }}
                                    </option>
                                </select>
                                <span class="ml-2">entries</span>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 text-lg-right px-0">
                            <div class="row">
                                <div class="col-lg-7 offset-lg-7"></div>
                                <!-- ABOVE LINE OF CODE IS NEEDED FOR UI STABILIZATION -->
                                <div class="col-lg-5">
                                    <div id="example1_filter" class="d-flex float-right align-items-center">
                                        <span>Search</span>
                                        <input
                                            class="ml-2 form-control form-control-sm grid-header-element searchbar-element"
                                            aria-controls="example1"
                                            type="search"
                                            [(ngModel)]="searchSRSLogs"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table id="jobid" class="table card-layout table-striped table mt-0">
                        <thead>
                            <tr>
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <!--<div class="header_title s_no">#</div>-->
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="legsLogSortBy = 'legNumber'; sortOrder = !sortOrder; LegNumber = !LegNumber"
                                        >
                                            Leg Number
                                            <i *ngIf="LegNumber == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="LegNumber == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="legsLogSortBy = 'origin'; sortOrder = !sortOrder; legOrigin = !legOrigin"
                                        >
                                            Origin
                                            <i *ngIf="legOrigin == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legOrigin == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                legsLogSortBy = 'destination'; sortOrder = !sortOrder; legDestination = !legDestination
                                            "
                                        >
                                            Destination
                                            <i *ngIf="legDestination == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legDestination == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                legsLogSortBy = 'previousStatus';
                                                sortOrder = !sortOrder;
                                                legPreviousStatus = !legPreviousStatus
                                            "
                                        >
                                            Previous Status
                                            <i *ngIf="legPreviousStatus == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legPreviousStatus == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                legsLogSortBy = 'updatedStatus';
                                                sortOrder = !sortOrder;
                                                legUpdatedStatus = !legUpdatedStatus
                                            "
                                        >
                                            Updated Status
                                            <i *ngIf="legUpdatedStatus == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legUpdatedStatus == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="legsLogSortBy = 'updatedOn'; sortOrder = !sortOrder; legUpdatedTime = !legUpdatedTime"
                                        >
                                            Updated Time
                                            <i *ngIf="legUpdatedTime == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legUpdatedTime == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="legsLogSortBy = 'updatedBy'; sortOrder = !sortOrder; legUpdatedBy = !legUpdatedBy"
                                        >
                                            Updated By
                                            <i *ngIf="legUpdatedBy == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legUpdatedBy == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                legsLogSortBy = 'operationType';
                                                sortOrder = !sortOrder;
                                                legOperationType = !legOperationType
                                            "
                                        >
                                            Operation Type
                                            <i *ngIf="legOperationType == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legOperationType == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                legsLogSortBy = 'previousValues';
                                                sortOrder = !sortOrder;
                                                legPreviousValues = !legPreviousValues
                                            "
                                        >
                                            Previous Values
                                            <i *ngIf="legPreviousValues == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legPreviousValues == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                legsLogSortBy = 'updatedValues';
                                                sortOrder = !sortOrder;
                                                legUpdatedValues = !legUpdatedValues
                                            "
                                        >
                                            Updated Values
                                            <i *ngIf="legUpdatedValues == true" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="legUpdatedValues == false" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let leg of SRSLogs
                                        | orderBy: legsLogSortBy : sortOrder
                                        | filter: searchSRSLogs
                                        | paginate
                                            : {
                                                  id: 'srsLogsPagination',
                                                  itemsPerPage: selectedPageForSRSLogs,
                                                  currentPage: currentPageForSRSLogs,
                                              };
                                    let i = index
                                "
                            >
                                <td>
                                    <div class="row_container">
                                        <div class="title_container width_70">
                                            <div class="row_title">Leg Number</div>
                                            <div class="row_detail">
                                                {{ leg.legNumber }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Origin</div>
                                            <div class="row_detail">
                                                <b>{{ leg.origin }}</b>
                                                <br />
                                                {{ leg.originAddress }}<br />
                                                {{ leg?.originAddressLocation }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Destination</div>
                                            <div class="row_detail">
                                                <b>{{ leg.destination }}</b>
                                                <br />
                                                {{ leg.destinationAddress }}<br />
                                                {{ leg?.destinationAddressLocation }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Previous Status</div>
                                            <div class="row_detail">
                                                {{ leg.previousStatus }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated Status</div>
                                            <div class="row_detail">
                                                {{ leg.updatedStatus }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated Time</div>
                                            <div class="row_detail">
                                                {{ leg.updatedOn | srTimezoneDate }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated By</div>
                                            <div class="row_detail">
                                                {{ leg.updatedBy }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Operation Mode</div>
                                            <div class="row_detail">
                                                {{ leg.operationType }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70 inline">
                                            <div class="row_title">Previous Values</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="leg.previousValues">
                                                    <div *ngFor="let value of leg.previousValues.split('|')" class="mb-1">
                                                        <div>
                                                            <span class="text-bold"
                                                                >{{ value.substring(0, value.indexOf(':')).trim() }}:
                                                            </span>
                                                            <ng-container *ngIf="(value | dateChecker).isDate; else elseBlock">
                                                                <div>{{ (value | dateChecker)?.value | srTimezoneDate }}</div>
                                                            </ng-container>
                                                            <ng-template #elseBlock>
                                                                <span>{{ (value | dateChecker).value }}</span>
                                                            </ng-template>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="leg.previousValues == null || leg.previousValues === ''"
                                                    >NA</ng-container
                                                >
                                            </div>
                                        </div>
                                        <div class="title_container width_70 inline">
                                            <div class="row_title">Updated Values</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="leg.updatedValues">
                                                    <div *ngFor="let value of leg.updatedValues.split('|')" class="mb-1">
                                                        <span class="text-bold">{{ value.substring(0, value.indexOf(':')).trim() }}: </span>
                                                        <ng-container *ngIf="(value | dateChecker).isDate; else elseBlock">
                                                            <div>{{ (value | dateChecker).value | srTimezoneDate }}</div>
                                                        </ng-container>
                                                        <ng-template #elseBlock>
                                                            <span>{{ (value | dateChecker).value }}</span>
                                                        </ng-template>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="leg.updatedValues == null || leg.updatedValues === ''"
                                                    >NA</ng-container
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="SRSLogs.length == 0" class="text-color"><b>No Record Available</b></div>
                    <div *ngIf="SRSLogs.length != 0" class="col-md-12 p-0">
                        <div id="left" class="col-md-6 p-0">
                            {{ SRSLogsPagination }}
                        </div>

                        <div id="right" class="col-md-6 pagination text-end">
                            <pagination-controls
                                id="srsLogsPagination"
                                [responsive]="responsive"
                                (pageChange)="currentPageForSRSLogs = $event; currentPageChange('SRSLogs')"
                            >
                            </pagination-controls>
                        </div>
                    </div>
                </div>
                <!-- Assignmnet logs  -->
                <div *ngIf="fromPage != 'common-itinerary'" id="assignmnetlogs" class="tab-pane">
                    <div class="col-md-12 col-sm-12 col-xs-12 px-0 mb-2">
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 px-0">
                            <div class="filter-options">
                                <span>Show</span>
                                <select
                                    class="ml-2 grid-header-element number-sort-filter"
                                    aria-controls="example1"
                                    name="example1_length"
                                    [(ngModel)]="selectedPageForAssignmnetLogs"
                                    (change)="selectMemberPage('AssignmnetLogs')"
                                >
                                    <option *ngFor="let number of numberOfEntries" [value]="number.numberOfEntries">
                                        {{ number.numberOfEntries }}
                                    </option>
                                </select>
                                <span class="ml-2">entries</span>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 text-lg-right px-0">
                            <div class="row">
                                <div class="col-lg-7 offset-lg-7"></div>
                                <!-- ABOVE LINE OF CODE IS NEEDED FOR UI STABILIZATION -->
                                <div class="col-lg-5">
                                    <div id="example1_filter" class="d-flex float-right align-items-center">
                                        <span>Search</span>
                                        <input
                                            class="ml-2 form-control form-control-sm grid-header-element searchbar-element"
                                            aria-controls="example1"
                                            type="search"
                                            [(ngModel)]="searchAssignmnetLog"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table id="jobid" class="table card-layout table-striped table mt-0">
                        <thead>
                            <tr>
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <!--<div class="header_title s_no">#</div>-->
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'legSquenceNumber';
                                                sortOrder = !sortOrder;
                                                assignmentLogLegSeqNumber = !assignmentLogLegSeqNumber
                                            "
                                        >
                                            Leg Seq.No.
                                            <i *ngIf="assignmentLogLegSeqNumber" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogLegSeqNumber" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'assignedMember';
                                                sortOrder = !sortOrder;
                                                assignmentLogName = !assignmentLogName
                                            "
                                        >
                                            Name
                                            <i *ngIf="assignmentLogName" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogName" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'originAddress';
                                                sortOrder = !sortOrder;
                                                assignmentLogOrigin = !assignmentLogOrigin
                                            "
                                        >
                                            Origin
                                            <i *ngIf="assignmentLogOrigin" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogOrigin" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'destinationAddress';
                                                sortOrder = !sortOrder;
                                                assignmentLogDestination = !assignmentLogDestination
                                            "
                                        >
                                            Destination
                                            <i *ngIf="assignmentLogDestination" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogDestination" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'createdOn';
                                                sortOrder = !sortOrder;
                                                assignmentLogUpdatedTime = !assignmentLogUpdatedTime
                                            "
                                        >
                                            Updated Time
                                            <i *ngIf="assignmentLogUpdatedTime" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogUpdatedTime" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'createdBy';
                                                sortOrder = !sortOrder;
                                                assignmentLogUpdatedBy = !assignmentLogUpdatedBy
                                            "
                                        >
                                            Updated By
                                            <i *ngIf="assignmentLogUpdatedBy" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogUpdatedBy" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'operationType';
                                                sortOrder = !sortOrder;
                                                assignmentLogOperationType = !assignmentLogOperationType
                                            "
                                        >
                                            Operation Type
                                            <i *ngIf="assignmentLogOperationType" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogOperationType" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'previousValues';
                                                sortOrder = !sortOrder;
                                                assignmentLogPreviousValues = !assignmentLogPreviousValues
                                            "
                                        >
                                            Previous Values
                                            <i *ngIf="assignmentLogPreviousValues" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogPreviousValues" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                assignmentLogSortBy = 'updatedValues';
                                                sortOrder = !sortOrder;
                                                assignmentLogUpdatedValues = !assignmentLogUpdatedValues
                                            "
                                        >
                                            Updated Values
                                            <i *ngIf="assignmentLogUpdatedValues" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!assignmentLogUpdatedValues" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let assigLog of assignmnetLog
                                        | orderBy: assignmentLogSortBy : sortOrder
                                        | filter: searchAssignmnetLog
                                        | paginate
                                            : {
                                                  id: 'assignmnetLogsPagination',
                                                  itemsPerPage: selectedPageForAssignmnetLogs,
                                                  currentPage: currentPageForAssignmnetLogs,
                                              };
                                    let i = index
                                "
                            >
                                <td>
                                    <div class="row_container">
                                        <div class="title_container width_70">
                                            <div class="row_title">Leg Seq.No.</div>
                                            <ng-container *ngIf="assigLog.legSquenceNumber === 'SR Changes'; else normalText">
                                                <span class="badge">{{ assigLog.legSquenceNumber }}</span>
                                            </ng-container>
                                            <ng-template #normalText>
                                                {{ assigLog.legSquenceNumber }}
                                            </ng-template>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Name</div>
                                            <ng-container *ngIf="!assigLog.customerPointOfContacts; else pointOfContacts">
                                                <div class="row_detail">
                                                    {{ assigLog.assignedMember }}
                                                </div>
                                            </ng-container>
                                            <ng-template #pointOfContacts>
                                                <div *ngFor="let contacts of assigLog.customerPointOfContacts">
                                                    {{ contacts }}
                                                </div>
                                            </ng-template>
                                            <div *ngIf="assigLog.vendorName" class="row_detail">
                                                <span class="text-bold"> Vendor : </span>{{ assigLog.vendorName }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Origin</div>
                                            <div *ngIf="assigLog.originAddress && assigLog.originAddress !== 'NA'; else noOriginAddress">
                                                <div class="row_detail text-bold">
                                                    {{ assigLog.originAddress }}
                                                </div>
                                                <div>{{ assigLog.originAddressStreet }}</div>
                                                <div>{{ assigLog.originAddressCityZipcode }}</div>
                                            </div>
                                            <ng-template #noOriginAddress>
                                                <div class="row_detail">NA</div>
                                            </ng-template>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Destination</div>
                                            <div
                                                *ngIf="
                                                    assigLog.destinationAddress && assigLog.destinationAddress !== 'NA';
                                                    else noDestinationAddress
                                                "
                                            >
                                                <div class="row_detail text-bold">
                                                    {{ assigLog.destinationAddress }}
                                                </div>
                                                <div>{{ assigLog.destinationAddressStreet }}</div>
                                                <div>{{ assigLog.destinationCityZipcode }}</div>
                                            </div>
                                            <ng-template #noDestinationAddress>
                                                <div class="row_detail">NA</div>
                                            </ng-template>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated Time</div>
                                            <div class="row_detail">
                                                {{ assigLog.createdOn | localDate: timeZone }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated By</div>
                                            <div class="row_detail">
                                                {{ assigLog.createdBy }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Operation Type</div>
                                            <div class="row_detail">
                                                {{ assigLog.operationType }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Previous Values</div>
                                            <div class="row_detail">
                                                <div
                                                    *ngIf="
                                                        assigLog.previousValues &&
                                                            assigLog.previousValues.trim() !== '' &&
                                                            assigLog.previousValues.trim() !== 'NA';
                                                        else noPreviousValues
                                                    "
                                                >
                                                    <div *ngFor="let value of assigLog.previousValues.split('|')">
                                                        <div>
                                                            <span class="text-bold"
                                                                >{{ value.substring(0, value.indexOf(':')).trim() }}:
                                                            </span>
                                                            <span *ngIf="(value | dateChecker).value !== 'NA'">
                                                                <ng-container *ngIf="(value | dateChecker).isDate; else elseBlock">
                                                                    <div>{{ (value | dateChecker).value | localDate: timeZone }}</div>
                                                                </ng-container>
                                                                <ng-template #elseBlock>
                                                                    <span>{{ (value | dateChecker).value }}</span>
                                                                </ng-template>
                                                            </span>
                                                            <span *ngIf="(value | dateChecker).value === 'NA'"> NA</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ng-template #noPreviousValues>
                                                    <div>NA</div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated Values</div>
                                            <div class="row_detail">
                                                <div
                                                    *ngIf="
                                                        assigLog.updatedValues &&
                                                            assigLog.updatedValues.trim() !== '' &&
                                                            assigLog.updatedValues.trim() !== 'NA';
                                                        else noUpdatedValues
                                                    "
                                                >
                                                    <div *ngFor="let value of assigLog.updatedValues.split('|')">
                                                        <div>
                                                            <span class="text-bold"
                                                                >{{ value.substring(0, value.indexOf(':')).trim() }}:
                                                            </span>
                                                            <span *ngIf="(value | dateChecker).value !== 'NA'">
                                                                <ng-container *ngIf="(value | dateChecker).isDate; else elseBlock">
                                                                    <div>{{ (value | dateChecker).value | localDate: timeZone }}</div>
                                                                </ng-container>
                                                                <ng-template #elseBlock>
                                                                    <span>{{ (value | dateChecker).value }}</span>
                                                                </ng-template>
                                                            </span>
                                                            <span *ngIf="(value | dateChecker).value === 'NA'"> NA</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ng-template #noUpdatedValues>
                                                    <div>NA</div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="assignmnetLog.length == 0" class="text-color"><b>No Record Available</b></div>
                    <div *ngIf="assignmnetLog.length != 0" class="col-md-12 p-0">
                        <div id="left" class="col-md-6 p-0">
                            {{ assignmnetLogsPagination }}
                        </div>

                        <div id="right" class="col-md-6 pagination text-end">
                            <pagination-controls
                                id="assignmnetLogsPagination"
                                [nextLabel]="R"
                                [previousLabel]="N"
                                [responsive]="responsive"
                                (pageChange)="currentPageForAssignmnetLogs = $event; currentPageChange('AssignmnetLogs')"
                            >
                            </pagination-controls>
                        </div>
                    </div>
                </div>

                <!-- Checklist Log  -->
                <div *ngIf="fromPage != 'common-itinerary'" id="checklistLogs" class="tab-pane">
                    <div class="col-md-12 col-sm-12 col-xs-12 px-0 mb-2">
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 px-0">
                            <div class="filter-options">
                                <span>Show</span>
                                <select
                                    class="ml-2 grid-header-element number-sort-filter"
                                    aria-controls="example1"
                                    name="example1_length"
                                    [(ngModel)]="selectedPageForChecklistLogs"
                                    (change)="selectMemberPage('CheckListLogs')"
                                >
                                    <option *ngFor="let number of numberOfEntries" [value]="number.numberOfEntries">
                                        {{ number.numberOfEntries }}
                                    </option>
                                </select>
                                <span class="ml-2">entries</span>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 text-lg-right px-0">
                            <div class="row">
                                <div class="col-lg-7 offset-lg-7"></div>
                                <!-- ABOVE LINE OF CODE IS NEEDED FOR UI STABILIZATION -->
                                <div class="col-lg-5">
                                    <div id="example1_filter" class="d-flex float-right align-items-center">
                                        <span>Search</span>
                                        <input
                                            class="ml-2 form-control form-control-sm grid-header-element searchbar-element"
                                            aria-controls="example1"
                                            type="search"
                                            [(ngModel)]="searchChecklistLogs"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table id="jobid" class="table card-layout table-striped table mt-0">
                        <thead>
                            <tr>
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                checklistLogSortBy = 'i'; sortOrder = !sortOrder; checklistLogIndex = !checklistLogIndex
                                            "
                                        >
                                            S.No.
                                            <i *ngIf="checklistLogIndex" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!checklistLogIndex" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                checklistLogSortBy = 'name'; sortOrder = !sortOrder; checklistLogName = !checklistLogName
                                            "
                                        >
                                            Checklist Item Name
                                            <i *ngIf="checklistLogName" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!checklistLogName" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                checklistLogSortBy = 'lastUpdatedOn';
                                                sortOrder = !sortOrder;
                                                checklistLogUpdatedOn = !checklistLogUpdatedOn
                                            "
                                        >
                                            Updated On
                                            <i *ngIf="checklistLogUpdatedOn" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!checklistLogUpdatedOn" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                checklistLogSortBy = 'lastUpdatedByName';
                                                sortOrder = !sortOrder;
                                                checklistLogUpdatedBy = !checklistLogUpdatedBy
                                            "
                                        >
                                            Updated By
                                            <i *ngIf="checklistLogUpdatedBy" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!checklistLogUpdatedBy" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                checklistLogSortBy = 'previousValue';
                                                sortOrder = !sortOrder;
                                                checklistLogPreviousValue = !checklistLogPreviousValue
                                            "
                                        >
                                            Previous Value
                                            <i *ngIf="checklistLogPreviousValue" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!checklistLogPreviousValue" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header_title width_70 cursorPointer"
                                            (click)="
                                                checklistLogSortBy = 'updatedValue';
                                                sortOrder = !sortOrder;
                                                checklistLogUpdatedValue = !checklistLogUpdatedValue
                                            "
                                        >
                                            Updated Value
                                            <i *ngIf="checklistLogUpdatedValue" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!checklistLogUpdatedValue" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let checklist of checkListLogs
                                        | orderBy: checklistLogSortBy : sortOrder
                                        | filter: searchChecklistLogs
                                        | paginate
                                            : {
                                                  id: 'checklistLogsPagination',
                                                  itemsPerPage: selectedPageForChecklistLogs,
                                                  currentPage: currentPageForCheckListLogs,
                                              };
                                    let i = index
                                "
                            >
                                <td>
                                    <div class="row_container">
                                        <div class="title_container width_70">
                                            <div class="row_title">S.No.</div>
                                            <div class="row_detail">
                                                {{ i + 1 }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Checklist Item Name</div>
                                            <div class="row_detail">
                                                {{ checklist.name }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Last Updated On</div>
                                            <div class="row_detail">
                                                {{ checklist.lastUpdatedOn | localDate: timeZone }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Last Updated By</div>
                                            <div class="row_detail">
                                                {{ checklist.lastUpdatedByName }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Previous Value</div>
                                            <div class="row_detail">
                                                {{ checklist.previousValue == true ? 'Checked' : 'Un Checked' }}
                                            </div>
                                        </div>
                                        <div class="title_container width_70">
                                            <div class="row_title">Updated Value</div>
                                            <div class="row_detail">
                                                {{ checklist.updatedValue == true ? 'Checked' : 'Un Checked' }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="checkListLogs.length == 0" class="text-color"><b>No Record Available</b></div>
                    <div *ngIf="checkListLogs.length != 0" class="col-md-12 p-0">
                        <div id="left" class="col-md-6 p-0">
                            {{ checkListLogsPagination }}
                        </div>
                        <div id="right" class="col-md-6 pagination text-end">
                            <pagination-controls
                                id="checklistLogsPagination"
                                [nextLabel]="R"
                                [previousLabel]="N"
                                [responsive]="responsive"
                                (pageChange)="currentPageForCheckListLogs = $event; currentPageChange('CheckListLogs')"
                            >
                            </pagination-controls>
                        </div>
                    </div>
                </div>

                <!-- Catering Logs  -->
                <div *ngIf="fromPage === 'Preview' && isCatering && isAdmin" id="cateringLogs" class="tab-pane">
                    <app-catering-logs [serviceRequestId]="serviceRequestId" (cateringLogsLength)="cateringLogsLength($event)">
                    </app-catering-logs>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="addNoteFeedback" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header content-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button" (click)="clearData()">
                    <i class="fa fa-close fa-md"></i>
                </button>
                <h4 class="modal-title">Add {{ header }}</h4>
            </div>
            <div class="modal-body">
                <div class="member-card">
                    <div class="row">
                        <div class="col-md-6">
                            <div *ngIf="header == 'Note' || header == 'Preview'" class="form-group">
                                <label>Category<span class="text-danger">*</span></label>
                                <select
                                    *ngIf="
                                        fromPage == 'vendor' ||
                                        fromPage == 'createItenary' ||
                                        fromPage == 'Itinary' ||
                                        (fromPage == 'Preview' &&
                                            user.role != roleName.CUSTOMER_ADMIN &&
                                            user.role != roleName.CUSTOMER_COORDINATOR)
                                    "
                                    class="form-control"
                                    name="selectedCategory"
                                    [(ngModel)]="selectedCategory"
                                >
                                    <option disabled value="">Category</option>
                                    <option *ngFor="let category of categoryList" [value]="category.appCategoryId">
                                        {{ category.name }}
                                    </option>
                                </select>
                                <select
                                    *ngIf="
                                        (fromPage != 'vendor' &&
                                            fromPage != 'createItenary' &&
                                            fromPage != 'Itinary' &&
                                            fromPage != 'Preview') ||
                                        user.role == roleName.CUSTOMER_ADMIN ||
                                        user.role == roleName.CUSTOMER_COORDINATOR
                                    "
                                    class="form-control"
                                    name="customerNoteCategory"
                                    [(ngModel)]="selectedCategory"
                                >
                                    <option disabled selected value="">Category</option>
                                    <option *ngFor="let category of categoriesForCustomer" [value]="category.appCategoryId">
                                        {{ category.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div *ngIf="tripIdListByServiceRequest != undefined && tripIdListByServiceRequest.length > 1" class="col-md-6">
                            <div *ngIf="header == 'Note'" class="form-group">
                                <label>Service Request<span class="text-danger">*</span></label>
                                <select
                                    class="form-control col-md-6"
                                    name="selectedTripId"
                                    [(ngModel)]="selectedTripId"
                                    (change)="changeTripId($event)"
                                >
                                    <option disabled selected value="undefined">Trip ID</option>
                                    <option *ngFor="let tripId of tripIdListByServiceRequest" [value]="tripId.serviceRequestId">
                                        {{ tripId.tripId }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{ header }}<span class="text-danger">*</span></label>
                                <textarea
                                    class="form-control"
                                    maxlength="501"
                                    [placeholder]="header"
                                    [(ngModel)]="noteFeedback"
                                    (ngModelChange)="noteSize($event)"
                                ></textarea>
                                <div *ngIf="display == true"><span style="color: red">Notes must not exceed 500 characters.</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                    data-dismiss="modal"
                    type="reset"
                    (click)="clearData()"
                >
                    Cancel
                </button>
                <button
                    *ngIf="tripIdListByServiceRequest == undefined"
                    class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                    (click)="saveNoteFeedbackData()"
                >
                    Save Changes
                </button>
                <button
                    *ngIf="tripIdListByServiceRequest != undefined && tripIdListByServiceRequest.length >= 1"
                    class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                    (click)="saveFinanceNote()"
                >
                    Save Changes
                </button>
            </div>
        </div>
    </div>
</div>
